var React = require('react');

function WireInline (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M20,16a4,4,0,0,0-3.86,3H14.5c-.81,0-1.5-.92-1.5-2V11h3.14a4,4,0,1,0,0-2H13V7A3.78,3.78,0,0,0,9.5,3H7.86a4,4,0,1,0,0,2H9.5c.81,0,1.5.92,1.5,2V17a3.78,3.78,0,0,0,3.5,4h1.64A4,4,0,1,0,20,16Zm0-8a2,2,0,1,1-2,2A2,2,0,0,1,20,8ZM4,6A2,2,0,1,1,6,4,2,2,0,0,1,4,6ZM20,22a2,2,0,1,1,2-2A2,2,0,0,1,20,22Z"})));
}

WireInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = WireInline;

WireInline.default = WireInline;
